<div class="modal-body">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_Date' | translate}}</ion-label> :
        {{ requestItem?.inserT_DATE | formatDate:isMobileApp}}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_RequestNo' | translate}}</ion-label> : {{
        requestItem?.reallocatioN_REQ_ID }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">Reason</ion-label> : {{ requestItem?.reallocatioN_REASON_DESCRIPTION }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_Add_JustificationForChange' | translate}}</ion-label> : {{
        requestItem?.justificatioN_TEXT }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_Add_JobSkill' | translate}}</ion-label> : {{
        requestItem?.joB_SKILL_NAME }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_Add_RequestedSpecification' | translate}}</ion-label> : {{
        requestItem?.vehiclE_SPEC_NAME }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="label">{{'Vehicle_ReAllocation_Add_OtherRequirement' | translate}}</ion-label> : {{
        requestItem?.additionaL_VEHICLE_REQUIREMENT }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="d-flex justify-content-center">
        <ion-button class="btn_secondary" (click)="closeModal()" (keydown.enter)="closeModal()">
          {{'CLOSE' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>